import { render, staticRenderFns } from "./BlogArticleResult.vue?vue&type=template&id=00361d4f"
import script from "./BlogArticleResult.vue?vue&type=script&lang=js"
export * from "./BlogArticleResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports